import '../sass/styles.scss';
import './bootstrap';
import ClipboardJS from 'clipboard';
import { Tooltip, Toast, Popover, Alert, Tab, Modal } from 'bootstrap';
window.Tab = Tab
window.Modal = Modal
window.Tooltip = Tooltip

const ArtisanApp = function () {
	const clipboardCopy = function () {
		if (document.querySelectorAll('.copy-clipboard').length > 0) {
			document.querySelectorAll('.copy-clipboard').forEach(element => {
				let options = {}
				if (element.dataset.callback) {
					options = {
						text: window[element.dataset.callback]
					}
				}

				const clipboard = new ClipboardJS(element, options);
				clipboard.on('success', (e) => {
					let text = e.trigger.dataset.copied;
					let old = e.trigger.getAttribute('data-bs-original-title');
					const tooltip = Tooltip.getOrCreateInstance(e.trigger);
					tooltip.setContent({ '.tooltip-inner': text });
					setTimeout(function () {
						tooltip.setContent({ '.tooltip-inner': old });
					}, 2000);
				});
			});
		}
	},
		appBootstrap = function () {
			var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
			var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
				return new Tooltip(tooltipTriggerEl)
			})
		},
		rangeSlider = function () {
			var slider = document.querySelectorAll('.range-slider');
			if (slider.length > 0) {
				slider.forEach(element => {
					var range = element.querySelector('.range-slider__range'),
						value = element.querySelector('.range-slider__value');
					value.innerHTML = value.previousElementSibling.value
					range.addEventListener('input', e => {
						value.innerHTML = e.target.value
					})
				});
			}
		},
		showLoaderOnSubmit = function () {
			if (document.querySelectorAll('form').length > 0) {
				document.querySelectorAll('form').forEach(element => {
					if (!element.classList.contains('no-app-loader')) {
						element.addEventListener('submit', e => {
							ArtisanApp.showLoader()
						})
					}
				});
			}
		},
		initPricingSwitch = function () {
			const radioButtons = document.querySelectorAll('#input-switch-monthly, #input-switch-yearly');

			function handlePricingSwitch() {
				const monthlyPlans = document.querySelectorAll('.mt-pricing-monthly');
				const yearlyPlans = document.querySelectorAll('.mt-pricing-yearly');

				if (monthlyPlans.length > 0 && yearlyPlans.length > 0) {
					if (document.getElementById('input-switch-monthly').checked) {
						// Show all monthly plans, hide all yearly plans
						monthlyPlans.forEach(plan => plan.classList.remove('d-none'));
						yearlyPlans.forEach(plan => plan.classList.add('d-none'));
					} else {
						// Show all yearly plans, hide all monthly plans
						monthlyPlans.forEach(plan => plan.classList.add('d-none'));
						yearlyPlans.forEach(plan => plan.classList.remove('d-none'));
					}
				}
			}

			radioButtons.forEach(radio => {
				radio.addEventListener('change', handlePricingSwitch);
			});

			handlePricingSwitch();
		},
		syncAuthForms = function () {
			const login = document.querySelector('[data-auth="login"]');
			const reg = document.querySelector('[data-auth="register"]');
			const authModeRadios = document.querySelectorAll('input[name="auth_mode"]');

			// Check if required elements exist
			if (!login || !reg || authModeRadios.length === 0) {
				return;
			}

			function sync() {
				const mode = document.querySelector('input[name="auth_mode"]:checked')?.value || 'login';
				if (mode === 'login') {
					login.classList.remove('d-none');
					reg.classList.add('d-none');
				} else {
					login.classList.add('d-none');
					reg.classList.remove('d-none');
				}
			}

			// Add event listeners only if elements exist
			authModeRadios.forEach(radio => {
				radio.addEventListener('change', sync);
			});

			// Initial sync
			sync();
		},
		initCheckout = function () {
			const radios = document.querySelectorAll('input[name="mt_gateway"]');
			const sets = document.querySelectorAll('#mt-gateway-fields .mt-gw-fields');
			function show(id) {
				sets.forEach(el => {
					el.style.display = (el.getAttribute('data-gw') === id) ? '' : 'none';
				});
			}
			radios.forEach(r => r.addEventListener('change', function () { show(this.value); }));
			const checked = document.querySelector('input[name="mt_gateway"]:checked');
			if (checked) show(checked.value);
		};

	return {
		init: function () {
			clipboardCopy();
			appBootstrap();
			showLoaderOnSubmit();
			rangeSlider();
			initPricingSwitch();
			syncAuthForms();
			initCheckout();
		},
		showLoader: function () {
			if (document.querySelector('#app-loader')) {
				document.querySelector('#app-loader').classList.remove('d-none')
			}
		},
		hideLoader: function () {
			if (document.querySelector('#app-loader')) {
				document.querySelector('#app-loader').classList.add('d-none')
			}
		},
		isJson: function (str) {
			try {
				JSON.parse(str);
			} catch (e) {
				return false;
			}
			return true;
		},
		humanFileSize: function (size) {
			var i = size == 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024));
			return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i];
		},
		toastError: function (message) {
			const html = `<div class="toast toast-danger" role="alert" aria-live="assertive" data-bs-delay="3000" aria-atomic="true" data-bs-autohide="true">
                            <div class="d-flex">
                                <div class="toast-body">${message}</div>
                                <button type="button" class="btn-close me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
                            </div>
                        </div>`;
			this.appendToast(html)
		},
		toastSuccess: function (message) {
			const html = `<div class="toast toast-success" role="alert" aria-live="assertive" data-bs-delay="3000" aria-atomic="true" data-bs-autohide="true">
                            <div class="d-flex">
                                <div class="toast-body">${message}</div>
                                <button type="button" class="btn-close me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
                            </div>
                        </div>`;
			this.appendToast(html)
		},
		appendToast: function (html) {
			if (!document.querySelector('.toast-container')) return;
			var child = document.createElement('div');
			child.innerHTML = html;
			child = child.firstChild;

			document.querySelector('.toast-container').prepend(child)
			this.initToast();
		},
		initToast: function () {
			var toastElList = [].slice.call(document.querySelectorAll('.toast-container .toast'))
			toastElList.map(function (toastEl) {
				toastEl.addEventListener('hidden.bs.toast', function () {
					toastEl.remove()
				})
				const toast = new Toast(toastEl, { autohide: true })
				toast.show()
			})
		},
		printResult: function (target, { title = null, header_code = null }) {
			title = title ? title : document.title
			const printIframe = document.createElement('iframe');
			printIframe.name = "printIframe";
			printIframe.style.position = "absolute";
			printIframe.style.top = "-1000000px";
			document.body.appendChild(printIframe);
			const print = (printIframe.contentWindow) ? printIframe.contentWindow : (printIframe.contentDocument.document) ? printIframe.contentDocument.document : printIframe.contentDocument;
			print.document.open();
			print.document.write(`<html><head><title>${title}</title>${header_code}`);
			print.document.write('<style>abbr[title]::after{content:" (" attr(title) ")"}.pagebreak{page-break-after:always;}pre{white-space:pre-wrap!important}blockquote,pre{border:1px solid #adb5bd;page-break-inside:avoid}img,tr{page-break-inside:avoid}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}@page{size:a3}body{min-width:992px!important}.container{min-width:992px!important}.table{border-collapse:collapse!important}.table td,.table th{background-color:#fff!important}.table-bordered td,.table-bordered th{border:1px solid #dee2e6!important}.table-dark{color:inherit}.table-dark tbody+tbody,.table-dark td,.table-dark th,.table-dark thead th{border-color:#dee2e6}.d-print-none{display:none;}</style></head><body style="background-color:#fff;">');
			print.document.write(target.innerHTML);
			print.document.write('</body></html>');
			print.document.close();
			setTimeout(function () {
				window.frames["printIframe"].focus();
				window.frames["printIframe"].print();
				document.body.removeChild(printIframe);
			}, 500);

			return false;
		},
		downloadAsTxt: function (elementOrText, { isElement = true, filename = null, fileMime = 'text/plain', fileType = null }) {
			const el = isElement ? document.querySelector(elementOrText) : null;

			const text = el
				? (el.tagName === 'TEXTAREA' || el.tagName === 'INPUT'
					? el.value
					: el.innerHTML?.trim() || '')
				: elementOrText;
			if (!text) {
				return;
			}

			if (!filename) {
				filename = Number(new Date()) + (fileType ? `.${fileType}` : '.txt');
			}

			var element = document.createElement('a');
			element.setAttribute('href', `data:${fileMime};charset=utf-8,` + encodeURIComponent(text));
			element.setAttribute('download', filename);
			element.style.display = 'none';
			document.body.appendChild(element);
			element.click();
			document.body.removeChild(element);
		},
		downloadFromUrl(url, fileName) {
			var xhr = new XMLHttpRequest();
			xhr.open("GET", url, true);
			xhr.responseType = "blob";
			xhr.onload = function () {
				var urlCreator = window.URL || window.webkitURL;
				var imageUrl = urlCreator.createObjectURL(this.response);
				var element = document.createElement('a');
				element.href = imageUrl;
				element.download = fileName;
				document.body.appendChild(element);
				element.click();
				document.body.removeChild(element);
			}
			xhr.send();
		},
		isJson: function (str) {
			try {
				JSON.parse(str);
			} catch (e) {
				return false;
			}
			return true;
		},
		initUpload: function (uploader, { filesGrid = null, maxFiles = 1, maxSize = null, fileExtensions = null, dropOnBody = false, fileSelectedCallback = false }, { extensionsError, sizeError, filesError }) {
			let filesList = [];
			const fileSelect = uploader.querySelector('[type=file]');
			const uploaderDrag = uploader.querySelector('label.file-drag');
			const fileDrag = dropOnBody ? document.body : uploaderDrag;
			const uploadWrapper = uploader.querySelector('.uploader-wrapper')

			fileSelect.addEventListener('change', fileSelectHandler, false);
			var xhr = new XMLHttpRequest();
			if (xhr.upload) {
				fileDrag.addEventListener('dragover', fileDragHover, false);
				fileDrag.addEventListener('dragleave', fileDragHover, false);
				fileDrag.addEventListener('drop', fileSelectHandler, false);
			}

			function fileDragHover(event) {
				event.stopPropagation();
				event.preventDefault();

				event.type === 'dragover' ? uploaderDrag.classList.add('hover') : uploaderDrag.classList.remove('hover');
			}

			function fileSelectHandler(e) {
				fileDragHover(e);
				var files = e.target.files || e.dataTransfer.files;
				([...files]).forEach(file => {
					parseFile(file);
				});

				if (typeof window[fileSelectedCallback] == 'function' && filesList.length > 0) {
					window[fileSelectedCallback](filesList)
				}

				if (typeof fileSelectedCallback == 'function') {
					fileSelectedCallback(filesList)
				}

				updateFileList();
			}

			// function output(filesPreview, file, index) {
			//     const src = URL.createObjectURL(file)
			//     const fileSize = ArtisanApp.humanFileSize(file.size)
			//     var div = document.createElement('div');
			//     div.className = `grid-item grid-item-${index}`
			//     div.bsToggle = 'tooltip'
			//     div.title = file.name
			//     div.innerHTML = `<div class="item-image">
			//                         <img src="${src}" />
			//                         <button type="button" class="btn btn-danger rounded-pill delete-item"></button>
			//                     </div>
			//                     <div class="content">
			//                         <p>${file.name}</p>
			//                         <span>${fileSize}</span>
			//                     </div>`
			//     div.querySelector('.delete-item').addEventListener('click', () => {
			//         deleteFile(index)
			//     })
			//     filesPreview.appendChild(div);
			//     new Tooltip(div, {})
			// }
			function output(filesPreview, file, index) {
				const src = URL.createObjectURL(file);
				const fileSize = ArtisanApp.humanFileSize(file.size);
				var div = document.createElement('div');
				div.className = `grid-item grid-item-${index}`;
				div.bsToggle = 'tooltip';
				div.title = file.name;

				// Check the file type and create the appropriate media element
				let mediaElement;
				if (file.type.startsWith('image/')) {
					mediaElement = `<img src="${src}" />`;
				} else if (file.type.startsWith('video/')) {
					mediaElement = `<video src="${src}" controls></video>`;
				} else {
					const fileName = file.name;
					const fileExtension = fileName.split('.').pop().toLowerCase();
					if (fileExtension === 'heic' || fileExtension === 'avif') {
						mediaElement = `<div class="image-preview-placeholder h-100 w-100 bg-white d-flex align-items-center justify-content-center display-1 text-muted"><i class="an an-image"></i></div>`;
					} else {
						mediaElement = `<p>Unsupported file type</p>`;
					}
				}

				div.innerHTML = `
                            <div class="item-image">
                                ${mediaElement}
                                <button type="button" class="btn btn-danger rounded-pill delete-item"></button>
                            </div>
                            <div class="content">
                                <p>${file.name}</p>
                                <span>${fileSize}</span>
                            </div>`;

				div.querySelector('.delete-item').addEventListener('click', () => {
					deleteFile(index);
				});
				filesPreview.appendChild(div);
				new Tooltip(div, {});
			}

			function updateFileList() {
				if (!filesGrid) {
					if (filesList.length == 0) {
						uploadWrapper.classList.remove('d-none')
						uploader.querySelector('.add-more')?.classList.add("d-none");
						uploader.querySelector('.uploader-after > .process-button')?.classList.add('d-none');
					} else {
						uploadWrapper.classList.add('d-none');
						uploader.querySelector('.uploader-after > .process-button')?.classList.remove('d-none');
					}
				}

				const filesPreview = !filesGrid ? uploader.querySelector('.files-grid') : document.querySelector(filesGrid)
				filesPreview.innerHTML = ''
				const dataTransfer = new DataTransfer()
				filesList.forEach((file, index) => {
					output(filesPreview, file, index)
					dataTransfer.items.add(file)
				});

				fileSelect.files = dataTransfer.files
			}

			function deleteFile(index) {
				Tooltip.getInstance(document.querySelector(`.grid-item-${index}`)).dispose()
				filesList.splice(index, 1)
				updateFileList()
			}

			function parseFile(file) {
				if (validation(file)) {
					uploader.querySelector('.uploader-wrapper').classList.add("d-none");
					uploader.querySelector('.uploader-error')?.classList.add("d-none");
					if (maxFiles == 1) {
						filesList = [file]
					} else if (validateMaxFiles(file)) {
						uploader.querySelector('.add-more')?.classList.remove("d-none");
						filesList.push(file)
					}
				} else {
					uploader.querySelector('.uploader-error')?.classList.remove("d-none");
					uploader.querySelector('label.file-drag').classList.remove("d-none");
				}
			}

			function validation(file) {
				return validateExtensions(file) && validateSize(file)
			}

			function validateExtensions(file) {
				const imageName = file.name;

				if (!fileExtensions) {
					return true;
				}

				const pattern = fileExtensions
					.split(',')
					.map(ext => ext.trim().replace(/^\./, ''))
					.join('|');

				const regex = new RegExp(`\\.(${pattern})$`, 'i');
				const state = regex.test(imageName);

				if (!state) {
					ArtisanApp.toastError(extensionsError);
				}

				return state;
			}

			function validateSize(file) {
				const state = !maxSize || file.size <= maxSize * 1024 * 1024
				if (!state) {
					ArtisanApp.toastError(sizeError)
				}

				return state;
			}

			function validateMaxFiles() {
				const state = !maxFiles || filesList.length < maxFiles;
				if (!state) {
					ArtisanApp.toastError(filesError)
				}

				return state
			}
		},
		checkDailyUsage: function ($limit, $usage) {
			try {
				if ($limit <= $usage) {
					return false;
				}
			} catch (e) {
				return false;
			}
			return true;
		}
	}
}();

window.ArtisanApp = ArtisanApp
window.ClipboardJS = ClipboardJS
document.addEventListener("DOMContentLoaded", function (event) {
	ArtisanApp.init();
});

